/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'
import config from "@/config/app"

import { Stores as moduleStores } from '@/modules'; // imports all store modules from modules folder


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    app: JSON.parse(JSON.stringify(config.app)),
    // user: {
    //   FullName: "",
    //   FirstName: "",
    //   LastName: "",
    //   Email: "",
    //   role: 'user',
    //   lang: 'en',
    //   loggedIn: false,
    // },
    user: {
      // FullName: "",
      // FirstName: "",
      // LastName: "",
      // Email: "",
      // role: 'user',
      // lang: 'en',
      loggedIn: false,
    },
    contacts: []
  },
  mutations: {
    addContact(state, newContact) {
      state.contacts.push(newContact);
    },
    updateContact(state, contact) {
      let contact_ids = state.contacts.map((item) => item.contact_uid);
      let itemIndex = contact_ids.indexOf(contact.contact_uid);
      let editedItem = {
        ...state.contacts[itemIndex],
        ...contact,
      };
      state.contacts.splice(itemIndex, 1, editedItem);
    },
  },
  modules: {
    ...moduleStores
  },
  getters: {
    isAuthenticated: state => {
      return state.app.user.loggedIn;
    }
  }
})
